export class Theme {
  getAppIcon(width: number): string {
    return `/theme/images/appIcon?w=${width}`;
  }

  getWebIcon({ width, height }: { width?: number; height?: number }): string {
    const size = [];
    if (width) size.push(`w=${width}`);
    if (height) size.push(`h=${height}`);

    return `/theme/images/webIcon?${size.join("&")}`;
  }
}
